import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-991aa18e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.qrcode)
    ? (_openBlock(), _createBlock("img", {
        key: 0,
        class: "qrcode-image",
        src: _ctx.qrcode,
        alt: "qrcode"
      }, null, 8, ["src"]))
    : _createCommentVNode("", true)
})